import { render } from "./IAmPartner.vue?vue&type=template&id=f9558eec"
import script from "./IAmPartner.vue?vue&type=script&lang=js"
export * from "./IAmPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__